export const messages = {
  en: {
    housekeepingType: {
      queryCondition: 'Query Conditions',
      typeName: 'Type Name',
      typeNamePlaceholder: 'Please enter type name',
      typeNameRequired: 'Type name is required',
      typeNameMaxLength: 'Type name is too long',
      showStatus: 'Show Status',
      showStatusPlaceholder: 'Please select show status',
      showStatusRequired: 'Show status is required',
      publicStatusPlaceholder: 'Is it public',
      housekeepingType: 'Housekeeping Type',
      logo: 'Logo',
      serviceDesc: 'Service Description',
      serviceDescPlaceholder: 'Optional, please enter service description',
      serviceDescMaxLength: 'Service description is too long',
      label: 'Label',
      labelPlaceholder: 'Optional, please enter label',
      labelMaxLength: 'Label is too long',
      sort: 'Sort',
      sortPlaceholder: 'Required, please enter sort number',
      sortRequired: 'Sort is required',
      sortNumber: 'Sort must be a number',
      smallIcon: 'Small Icon',
      iconRequired: 'Icon is required',
      addTitle: 'Add Housekeeping Type',
      editTitle: 'Edit Housekeeping Type',
      confirmDelete: 'Confirm Delete',
      confirmDeleteContent: 'Are you sure to delete this housekeeping type?',
      publicType: 'Public Type'
    }
  },
  zh: {
    housekeepingType: {
      queryCondition: '查询条件',
      typeName: '类别名称',
      typeNamePlaceholder: '请输入类别名称',
      typeNameRequired: '类别名称不能为空',
      typeNameMaxLength: '类别名称太长',
      showStatus: '是否显示',
      showStatusPlaceholder: '请选择是否显示',
      showStatusRequired: '是否显示不能为空',
      publicStatusPlaceholder: '是否公共',
      housekeepingType: '家政类型',
      logo: 'logo',
      serviceDesc: '服务描述',
      serviceDescPlaceholder: '选填，请填写服务描述',
      serviceDescMaxLength: '服务描述太长',
      label: '标签',
      labelPlaceholder: '选填，请填写标签',
      labelMaxLength: '标签描述太长',
      sort: '排序',
      sortPlaceholder: '必填，请填写排序',
      sortRequired: '排序不能为空',
      sortNumber: '排序不是有效数字',
      smallIcon: '小图标',
      iconRequired: '小图标不能为空',
      addTitle: '添加家政类型',
      editTitle: '编辑家政类型',
      confirmDelete: '确认删除',
      confirmDeleteContent: '确定删除该家政类型吗？',
      publicType: '公共类别'
    }
  }
}